import { isEmpty } from './utils';
import { trackEvent } from './trackEvent';
import { ABTestData } from './types';

/**
 * AB test tracking
 * @param {object} abTestData An object containing
 * @param {string} abTestData.testGroup {control|variant}
 * @param {string} abTestData.additional {control|variant}
 * @param {string} [abTestData.additional.cdnTest1] string containing 'test_name - test_group'
 * @param {string} [abTestData.additional.cdnTest2] string containing 'test_name - test_group'
 * @param {string} [abTestData.additional.cdnTest3] string containing 'test_name - test_group'
 * @param {string} [abTestData.additional.sharedControl] fired to indicate control group
 * @param {string} pageContext contextual information to help filtering, such as 'pdp' or 'sb'
 */
export function trackAbTestEvent(abTestData: ABTestData | null, pageContext: string): void {
    if (!!abTestData && !isEmpty(abTestData.additional)) {
        trackEvent({
            category: 'a/b testing',
            action: pageContext, // GA treats 'action' like a sub-category for the purposes of AB test filtering
            label: abTestData.testGroup,
            additional: abTestData.additional,
        });
    }
}

/**
 * AB test tracking for user AB tests
 * @param {object} abTestData An object containing
 * @param {string} abTestData.testName
 * @param {boolean} abTestData.isInVariant whether the user is in the control or variant bucket
 * @param {number} abTestData.variantPercentage percentage of users that currently receive the variant treatment
 */
export function trackUserAbTestEvent({
    testName,
    isInVariant,
    variantPercentage,
}: {
    testName: string;
    isInVariant: boolean;
    variantPercentage: number;
}): void {
    trackEvent({
        category: 'a/b testing v2',
        action: testName,
        label: isInVariant ? 'variant' : 'control',
        value: variantPercentage,
    });
}
